<template>
  <div class="home">
    <h3 class="title">確認訂單金額</h3>
    <div class="cart-list">
      <div class="after"></div>
      <span class="list-num">訂單編號 201907310111</span>
      <template v-for="(item,index) in listProducts">
        <div v-bind:key="index" :dum="index" class="list-content">
          <img class="image" :src="item.image" >
          <div class="text-box">
            <div class="product-title">{{item.title}}</div>
            <div class="product-content">{{item.content}}</div>
          </div>
          <div class="count-box">
            <div v-bind:numbb="item.id"  class="count-btn"  @click="addQty(-1,index)">
              <img class="icon" :src="btn1">
            </div>
            <span class="num"><span class="num2">{{item.Qty}}</span></span>
            <div  class="count-btn" @click="addQty(1,index)">
              <img class="icon" :src="btn2" >
            </div>
          </div>
          <span class="price-h">$ {{item.total}}</span>
          <div class="btn-trash" @click="cancel(index)">
            <img class="icon" :src="btn3">
          </div>
        </div>
      </template>
      <div class="total-box">
        <span class="total">Total</span>
        <span class="price-num">$ {{tatal}}</span>
      </div>
    </div>
    <payBtnBar/>
    <span class="note">注意事項<br>
    ‧假文字假文字假文字假文字假文字，假文字假文字假文字假文字。<br>
    ‧這也是假文字假文字假文字，假文字假文字假文字。<br>
    ‧這還是假文字假文字，假文字假文字假文字有夠多的假文字。
    </span>
  </div>
  
</template>

<style lang="scss">
.home{
  width: 930px;
  display: inline-block;
}
.title{
  margin-top: 16px;
  width: 100%;
  font-size: 22px;
  font-weight: 700;
  color: $secondary-color;
  text-align: left;
}
.cart-list{
  margin-top: 10px;
  width: 100%;
  border: 2px solid $secondary-color;
  border-radius: 10px;
  padding: 20px;
  position: relative;
  margin-bottom: 40px;
  text-align: center;
  .after{
    display: inline-block;
    position: absolute;
    left: 50%;
    width: 30px;
    height: 15px;
    transform: translateX(-50%);
    border-style: solid;
    border-width: 10px 15px 0 15px;
    border-color: $secondary-color transparent transparent transparent;
    bottom: -16px;
  }
  .list-num{
    display: block;
    font-size: 18px;
    text-align: left;
    margin-bottom: 20px;
  }
  .list-content{
    width: 100%;
    height: 121px;
    border-bottom: 1px solid $mid-color;
    margin-bottom: 20px;
    padding-bottom: 20px;
    text-align: left;
    display: flex;
    // justify-content: center;
    align-items: center;
    position: relative;
  }
  .total-box{
    text-align: right;
    .total{
      font-size: 18px;
      color: $secondary-color;
      margin-right: 85px;
    }
    .price-num{
      font-size: 24px;
      font-weight: 700;
      color: $secondary-color;
    }
  }
}
.image{
  display: inline-block;
  width: 150px;
  height: 100%;
  background-size: cover;
}
.text-box{
  display: inline-block;
  width: 350px;
  height: 100%;
  margin-left: 30px;
  margin-right: 60px;
  .product-title{
    font-size: 18px;
  }
  .product-content{
    font-size: 14px;
    color: $mid-color;
    margin-top: 6px;
  }
}
.count-box{
  // width: 140px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 15px;
  .count-btn{
    user-select: none;
    height: 30px;
    width: 30px;
    border: 1px solid $mid-color;
    padding: 7px;
    line-height: 6px;
    cursor: pointer;
  }
  .num{
    user-select: none;
    width: 80px;
    height: 30px;
    border-top: 1px solid $mid-color;
    border-bottom: 1px solid $mid-color;
    text-align: center;
    padding: 1px;
    .num2{
      transform: scale(0.8)
    }
  }
}
.price-h{
  user-select: none;
  width: 95px;
  height: 100%;
  line-height: 100px;
  font-size: 18px;
  text-align: center;
}
.btn-trash{
  position: absolute;
  top: 0;
  right: 0;
  width: 40px;
  height: 40px;
  line-height: 125px;
  cursor: pointer;
  .icon{
    width: 100%;
    height: 100%;
  }
}
.note{
  width: 100%;
  font-size: 14px;
  margin-bottom: 60px;
  color: $mid-color;
  text-align: left;
}

//**************media*********************************************************************
@media screen and (max-width:415px){
  .home{
     width: 100%;
  }
  .title{
    width: 320px;
    margin: 0 auto;
    margin-top: 24px;
    font-size: 14px;
    font-weight: 700;
    text-align: center;
  }
  .cart-list{
    margin-top: 8px;
    width: 100%;
    border:none;
    border-top: 2px solid $secondary-color;
    border-bottom: 2px solid $secondary-color;
    border-radius: 0px;
    padding: 10px 15px;
    margin-bottom: 20px;
    .list-num{
      font-size: 14px;
      margin-bottom: 10px;
    }
    .list-content{
      border-top: 1px solid $mid-color;
      margin-bottom: -1px;
      padding: 15px 0 10px 0;
      text-align: left;
      flex-wrap: wrap;
      justify-content: flex-end;
    }
    .total-box{
      margin-top: 15px;
      text-align: right;
      .total{
        font-size: 14px;
        margin-right: 10px;
      }
      .price-num{
        font-size: 18px;
      }
    }
  }
  .image{
    width: 20%;
    height: auto;
    background-size: cover;
  }
  .text-box{
    display: inline-block;
    width: 74%;
    height: 51px;
    margin-left: 13px;
    margin-right: 0px;
    .product-title{
      font-size: 12px;
    }
    .product-content{
      font-size: 10px;
      margin-top: 2px;
    }
  }
  .count-box{
    margin-top: 12px;
    height: 22px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 15px;
    .count-btn{
      height: 22px;
      width: 22px;
      border: 1px solid $mid-color;
      padding: 0;
      padding: 3px;
      padding-bottom: 8px;
      line-height: 6px;
    }
    .num{
      width: 40px;
      height: 22px;
      line-height: 14px;
      border-top: 1px solid $mid-color;
      border-bottom: 1px solid $mid-color;
      text-align: center;
      padding: 1px;
      .num2{
        transform: none;
        font-size: 10px;
      }
    }
  }
  .price-h{
    margin-top: 12px;
    width: 78px;
    height: 18px;
    line-height: 18px;
    font-size: 12px;
    margin-right: 30px;
  }
  .btn-trash{
    position: absolute;
    top: 75%;
    width: 25px;
    height: 25px;
    transform: translateY(-25%);
    .icon{
      position: absolute;
      top:0;
      left: 0;
    }
  }
  .note{
    font-size: 12px;
    width: auto;
    margin-left: 12px;
    margin-right: 12px;
  }
}
</style>

<script>
import image from "../assets/headphoneIMGL4494_TP_V4.png"
import image2 from "../assets/ipadpro-9_TP_V4.png"
import image3 from "../assets/nono.png"
import image4 from "../assets/nonono.png"
import btn1 from "../assets/icon_less-01.svg"
import btn2 from "../assets/icon_add-01.svg"
import btn3 from "../assets/order_btn_delete_normal-01.svg"

import payBtnBar from '@/components/payBtnBar.vue'

export default {
  name: 'home',
  components: {
    payBtnBar
  },
  data: function () {
      return {
          btn1: btn1,
          btn2: btn2,
          btn3: btn3,
          listProducts: [
            { 
              title: 'NearStone 頂級監聽級耳罩式耳機',
              content: '創新的動圈式10毫米寬帶單體 實現了功率強勁 降低了聲學應力的影響 搭載...',
              Qty: 1,
              price: 2999,
              image: image,
              total: 2999,
            },
            { 
              title: 'Bpple 2018 QPad Air 128G 太空灰',
              content: '9.7吋 Retina顯示器 可拍攝 1080p 影片 120 萬像素 FaceTime HD 攝錄鏡頭...',
              Qty: 2,
              price: 12000,
              image: image2,
              total: 24000,
            },
            { 
              title: 'SOPOLA棒樂 三段風磁吸充電式風扇',
              content: '四葉風扇設計，風力很強勁 分離式磁吸底座，手持站立方便兩用 三段式風速...',
              Qty: 1,
              price: 790,
              image: image3,
              total: 790,
            },{ 
              title: '3.1A雙USB充電器感光小夜燈',
              content: '隱藏式插頭 高透光霧化燈罩 三段式控制開關 光控感應器 雙USB充電插孔 附...',
              Qty: 5,
              price: 300,
              image: image4,
              total: 1500,
            }
          ]
      }
  },
  computed:{
    tatal(){
      let cost = 0
      for(let i=0; i<this.listProducts.length; i++){
        cost+=this.listProducts[i].total
      }
      return cost
    }
  },
  methods: {
    addQty(num,ind){
      let pro = this.listProducts[ind]
      let test = pro.Qty+num
      if(test<1 || test>5)return
      pro.Qty = test
      pro.total = pro.Qty * pro.price
      this.setCost()
    },
    cancel(id){
      if(this.listProducts.length<=1){
        alert('不能再刪了啦><')
        return
      }
      // this.listProducts[id].title='哈哈哈'
      this.listProducts.splice(id,1)
      this.setCost()
    },
    setCost(){
      this.$store.commit('set_age',this.tatal)
    }
  }
}


// @ is an alias to /src
</script>
